@if (isLoading) {
    <app-progress-spinner></app-progress-spinner>
}

@if (!isLoading) {
    <div class="container" style="padding-bottom: 10.84%">
        <h3>{{ "Choose-Country" | translate }}</h3>
        <div class="row">
            <div class="col-md-3 col-sm-12 continent-container">
                <span class="continent">EUROPE</span>
                <div>
                    @for (c of countryMap.get("EUROPE"); track c) {
                        <div class="countryGroup">
                            <a class="country" (click)="countryOnClick(c)">{{
                                c.name
                            }}</a>
                            @if (clickedCountry === c) {
                                @for (l of c.locales; track l) {
                                    <div
                                        class="language"
                                        (click)="languageOnClick(l)"
                                        (keydown.enter)="languageOnClick(l)"
                                    >
                                        {{ l.languageName }}
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="col-md-3 col-sm-12 continent-container">
                <div class="row d-block mb-3">
                    <span class="continent">AMERICA</span>
                    <div>
                        @for (c of countryMap.get("AMERICA"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="row d-block mb-3">
                    <span class="continent">SOUTH AMERICA</span>
                    <div>
                        @for (c of countryMap.get("SOUTH AMERICA"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-12 continent-container">
                <div class="row d-block mb-3">
                    <span class="continent">OCEANIA</span>
                    <div>
                        @for (c of countryMap.get("OCEANIA"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="row d-block mb-3">
                    <span class="continent">ASIA</span>
                    <div>
                        @for (c of countryMap.get("ASIA"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-12 continent-container">
                <div class="row d-block mb-3">
                    <span class="continent">AFRICA</span>
                    <div>
                        @for (c of countryMap.get("AFRICA"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="row d-block mb-3">
                    <span class="continent">GLOBAL</span>
                    <div>
                        @for (c of countryMap.get("GLOBAL"); track c) {
                            <div class="countryGroup">
                                <a
                                    class="country"
                                    (click)="countryOnClick(c)"
                                    >{{ c.name }}</a
                                >
                                @if (clickedCountry === c) {
                                    @for (l of c.locales; track l) {
                                        <div
                                            class="language"
                                            (click)="languageOnClick(l)"
                                            (keydown.enter)="languageOnClick(l)"
                                        >
                                            {{ l.languageName }}
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
